/** @format */

import { createContext, useState } from 'react';

export const DialogContext = createContext({
  open: false,
  setOpen: () => {}
});

export const DialogProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  return <DialogContext.Provider value={{ open, setOpen }}>{children}</DialogContext.Provider>;
};
